export enum TripPartEuropeMode {
  Group = 1,
  Single = 2,
  Mix = 3,
  Skip = 4,
}
